import { Box, Spinner, Text } from '@chakra-ui/react';
import { ChakraStylesConfig, Select } from 'chakra-react-select';
import { MdArrowDropDown } from 'react-icons/md';
import { eliminateHtmlTags } from '../../shared/utils';

export type ISelect = {
  value: string;
  label: string;
  isdisabled?: boolean;
};

const chakraStyles: ChakraStylesConfig = {
  menu: (provided, state) => {
    return {
      ...provided,
      zIndex: 9999,
    };
  },
};

export const CustomSelect = (props: any) => {
  const getValue = () => {
    if (props.isMulti) {
      return props.value;
    }

    if (!props.defaultItem || !props.options || !props.defaultItem?.value) {
      return props.defaultItem;
    }

    const matchedOption = props.options.find(
      (option: any) => option?.value === props.defaultItem?.value
    );

    return matchedOption || props.defaultItem;
  };

  return (
    <Box
      minW={props.width ? props.width : '183px'}
      maxW={props.maxWidth || 'none'}
    >
      <Text
        fontWeight="semibold"
        fontSize="sm"
        lineHeight="17px"
        color="text.secondary"
        fontFamily="Inter"
        mb={props.label ? 2 : 0}
      >
        {props.label}
      </Text>
      <Select
        {...props}
        chakraStyles={props.chakraStyles ? props.chakraStyles : chakraStyles}
        isOptionDisabled={(option: any) => option.isdisabled}
        icon={props.isLoading && <Spinner />}
        useBasicStyles
        isSearchable={props.isSearchableEnabled !== false}
        onChange={(e: any) => {
          if (props.isMulti) {
            props.onChange(e);
          } else {
            props.showLabels
              ? props.onChange(eliminateHtmlTags(e.label))
              : props.onChange(eliminateHtmlTags(e.value));
          }
        }}
        value={getValue()}
        options={props.options}
      />
    </Box>
  );
};

export default CustomSelect;
